import { useState, useEffect } from 'react';
import { getQueues } from 'services/bs-sector-measurable/measurableDataService';

export const useQueues = ({ item, col, showTooltip }) => {
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchQueues = () => {
    const isoStr = col.replace(' ', 'T');

    setLoading(true);
    return getQueues({
      measurableId: item.id,
      date: isoStr,
      scheduleType: item.scheduleType
    })
      .then(res => {
        setQueues(res.data || []);
        setHasFetched(true);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (showTooltip && !hasFetched) {
      fetchQueues();
    }
  }, [showTooltip]);

  const refetch = () => {
    setHasFetched(false);
    return fetchQueues();
  };

  return { queues, loading, refetch };
};